import { Component, DoCheck, ViewChild, Input, Output, EventEmitter } from '@angular/core'
import { NgForm } from '@angular/forms';
import { StepDto } from '../../../../models/StepDTO';

@Component({
  selector: 'wdm-containerOcr-form',
  styleUrls: ['../../../../styles/components/steps.scss'],
  templateUrl: 'container-ocr-form.component.html',
})

export class ContainerOcrFormComponent implements DoCheck {

  @ViewChild('containerForm', { static: true }) private containerForm: NgForm;
  @Input() stepInfo: StepDto;
  @Output() errors: EventEmitter<boolean> = new EventEmitter<boolean>(true);


  constructor() {
  }

  ngOnInit() {
  }

  ngDoCheck(): void {
   
    if (this.containerForm.status === 'INVALID') {
      this.errors.emit(true);
    } else {
      this.errors.emit(false);
      this.stepInfo.state = "OK";
    }
  }

  forceValidation() {
    this.containerForm.controls.title.markAsTouched();
    this.containerForm.controls.description.markAsTouched();
  }

}
